import { useEffect, useState } from 'react';
import TStrings from '../QuestionComponents.i18n';
import { PanelItemProps } from './SignaturePanel.types';
import TextInput from '~/components/TextInput';
import { useDebounceValue } from '~/lib/useDebounce';
import { signatureTextToSvgString } from './Signature.utils';

const DEBOUNCE_TYPE_CONFIG = {
    options: { trailing: true, leading: false },
    timeout: 300, //ms
};

type SignatureTypeProps = PanelItemProps;

const SignatureType = ({
    readOnly,
    onSignatureChanged,
    className,
}: SignatureTypeProps) => {
    const [signatureText, setSignatureText] = useState('');
    const [debouncedText] = useDebounceValue(
        signatureText,
        DEBOUNCE_TYPE_CONFIG.timeout,
        DEBOUNCE_TYPE_CONFIG.options,
    );

    useEffect(() => {
        signatureTextToSvgString(debouncedText).then(svgString =>
            onSignatureChanged(svgString),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedText]);

    return (
        <div className={`flex relative grow flex-col justify-end ${className}`}>
            <div className="flex grow flex-col justify-center items-center">
                <TextInput
                    disabled={readOnly}
                    className="flex w-[100%] themed-text"
                    inputClassName="flex bg-transparent !max-w-none text-center !border-0 text-7xl font-handwritten"
                    id="signature.typed"
                    placeholder={TStrings.SIGNATURE_TYPE_PLACEHOLDER}
                    autoFocus={true}
                    value={signatureText}
                    onChange={setSignatureText}
                />
                <div className="w-[50%] border-b themed-border" />
            </div>
        </div>
    );
};
export default SignatureType;
